// extracted by mini-css-extract-plugin
export var videoPresentation__btn = "videoPresentation-module--video-presentation__btn--53bf3";
export var videoPresentation__video = "videoPresentation-module--video-presentation__video--63b09";
export var videoPresentation__videoText = "videoPresentation-module--video-presentation__video-text--905f5";
export var videoPresentation__videoWrapper = "videoPresentation-module--video-presentation__video-wrapper--046ed";